export default {"src":"/_next/static/media/Group50-Dark.c945b18b.svg","height":22,"width":89};